export default __webpack_public_path__ + "static/media/maure_de_bretagne13.51eb95b8.jpg";